import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

interface TestimonialSingleProps {
  quote: string;
  author: string;
  subtitle?: string;
}

export default function TestimonialSingle({
  quote,
  author,
  subtitle,
}: TestimonialSingleProps) {
  return (
    <section className="flex flex-col items-center text-center px-5">
      <div className="flex items-center justify-center gap-1">
        {Array.from({ length: 5 }).map((_, i) => (
          <FontAwesomeIcon
            key={i}
            icon={faStar}
            className="text-star text-[13px]"
          />
        ))}
      </div>

      <p className="font-body font-medium text-[16px] md:text-[20px] leading-[1.35] text-[#1e1c1c] text-center max-w-[560px] mt-4">
        {quote}
      </p>

      <div className="flex flex-col items-center gap-1 mt-4">
        <span className="font-body font-medium text-[16px] text-[#1e1c1c]">
          {author}
        </span>
        {subtitle && (
          <span className="font-body font-medium text-[14px] text-[#1e1c1c] opacity-70">
            {subtitle}
          </span>
        )}
      </div>
    </section>
  );
}
